<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title" style="display: flex;align-items: center;">
					ព័ត៌មានអតិថិជន
					<router-link :to="'/clients/bet_provider_detail/' + client.hash">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>currency_exchange</md-icon>
							<md-tooltip md-direction="top">ប្រវត្តិភ្នាល់តាមអ្នកផ្តល់សេវា</md-tooltip>
						</md-button>
					</router-link>
					<router-link :to="'/clients/game_detail/' + client.hash">
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>gamepad</md-icon>
							<md-tooltip md-direction="top">ប្រវត្តិបើកហ្គេមទាំងអស់</md-tooltip>
						</md-button>
					</router-link>
					<md-button class="md-just-icon md-simple md-info" @click="resetPassword" v-if="$store.state.authentication.account_type != 'ad'">
						<md-icon>password</md-icon>
							<md-tooltip md-direction="top">បង្កើតពាក្យសំងាត់ថ្មី</md-tooltip>
					</md-button>
					<md-button class="md-just-icon md-simple md-primary" @click="verify" v-if="client.verified == 0">
						<md-icon>verified</md-icon>
						<md-tooltip md-direction="top">បញ្ជាក់គណនី</md-tooltip>
					</md-button>
					<md-button class="md-just-icon md-simple md-primary" @click="unverify" v-if="client.verified == 1">
						<md-icon>remove_done</md-icon>
						<md-tooltip md-direction="top">ដកការបញ្ជាក់គណនី</md-tooltip>
					</md-button>
				</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដ</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.id).length > 0"><b>m-{{config.orderlify(client.id)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះចូលប្រព័ន្ធ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.hash_id).length > 0"><b>{{client.username}} <md-icon class="verify" v-if="client.verified == 1">verified</md-icon></b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0"><b>{{client.name}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0"><b>{{client.phone}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ធនាគារ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="client.bank_type_id != null"><b>{{client.bank_type}} {{client.account_name}} {{client.account_number}}</b></span>
							<span v-else><b>N/A</b></span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>ថ្ងៃចូលប្រព័ន្ធចុងក្រោយ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.last_login).length > 0"><b>{{config.datelify(client.last_login)}}</b> ({{config.timelify(client.last_login)}})</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃបានបង្កើត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.created_date).length > 0"><b>{{config.datelify(client.created_date)}}</b> ({{config.timelify(client.created_date)}})</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ចំនួនចូលក្នុងប្រព័ន្ធ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.total_login).length > 0"><b>{{client.total_login}} ដង</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ស្ថានភាព</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.status).length > 0">
								<span class="green" v-if="client.status == 1">{{ config.getStatus(client.status) }}</span>
								<span class="error" v-if="client.status == 0">{{ config.getStatus(client.status) }}</span>
							</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ទឹកប្រាក់ក្នុងគណនី</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">គណនីគោល</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.balance).length > 0"><b>{{config.moneylify(client.balance)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>គណនីកីឡា</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.sport_balance).length > 0"><b>{{config.moneylify(client.sport_balance)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>គណនីកាស៊ីណូ និងជល់មាន់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.casino_balance).length > 0"><b>{{config.moneylify(client.casino_balance)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>គណនីបាញ់ត្រី</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.fishing_balance).length > 0"><b>{{config.moneylify(client.fishing_balance)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>គណនីស្លត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.slot_balance).length > 0"><b>{{config.moneylify(client.slot_balance)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>គណនីឡូតូ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.keno_balance).length > 0"><b>{{config.moneylify(client.keno_balance)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានស្ថិតិអំពីអតិថិជន</h3>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>paid</md-icon>
					</template>
					<template slot="content">
						<p class="category">ដាក់ទឹកប្រាក់សរុប</p>
						<h3 class="title">{{config.moneylify(data.total_deposit)}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>paid</md-icon>
					</template>
					<template slot="content">
						<p class="category">ដកទឹកប្រាក់សរុប</p>
						<h3 class="title">{{config.moneylify(data.total_withdraw)}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>paid</md-icon>
					</template>
					<template slot="content">
						<p class="category">ទឹកប្រាក់អតិថិជនភ្នាល់សរុប</p>
						<h3 class="title">{{config.moneylify(data.total_bet * -1)}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>paid</md-icon>
					</template>
					<template slot="content">
						<p class="category">ទឹកប្រាក់អតិថិជនឈ្មះសរុប</p>
						<h3 class="title">{{config.moneylify(data.total_win)}}</h3>
					</template>
				</stats-card>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ការកំណត់អ្នកផ្តល់សេវា</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<md-table v-if="disableProviderList.length > 0">
					<md-table-row>
						<md-table-head>ឈ្មោះ</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(disableProvider, index) in disableProviderList.slice(0, parseInt(disableProviderList.length / 3))">
						<md-table-cell>{{disableProvider.provider_name}}</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="disableProvider.upd_id != null">មិនអាចលេង</span>
							<span class="green" v-if="disableProvider.upd_id == null">អាចលេង</span>
						</md-table-cell>
						<md-table-cell>
							<div style="cursor: pointer;" v-if="disableProvider.upd_id != null" @click="enableProvider(disableProvider.upd_id)">
								<md-icon>play_circle</md-icon>
								<md-tooltip md-direction="top">ដាក់អោយលេង</md-tooltip>
							</div>
							<div style="cursor: pointer;" v-if="disableProvider.upd_id == null" @click="disableProviderFunc(disableProvider.provider_id)">
								<md-icon>stop_circle</md-icon>
								<md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip>
							</div>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<md-table v-if="disableProviderList.length > 0">
					<md-table-row>
						<md-table-head>ឈ្មោះ</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(disableProvider, index) in disableProviderList.slice(parseInt(disableProviderList.length / 3), 2*parseInt(disableProviderList.length / 3))">
						<md-table-cell>{{disableProvider.provider_name}}</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="disableProvider.upd_id != null">មិនអាចលេង</span>
							<span class="green" v-if="disableProvider.upd_id == null">អាចលេង</span>
						</md-table-cell>
						<md-table-cell>
							<div style="cursor: pointer;" v-if="disableProvider.upd_id != null" @click="enableProvider(disableProvider.upd_id)">
								<md-icon>play_circle</md-icon>
								<md-tooltip md-direction="top">ដាក់អោយលេង</md-tooltip>
							</div>
							<div style="cursor: pointer;" v-if="disableProvider.upd_id == null" @click="disableProviderFunc(disableProvider.provider_id)">
								<md-icon>stop_circle</md-icon>
								<md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip>
							</div>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<md-table v-if="disableProviderList.length > 0">
					<md-table-row>
						<md-table-head>ឈ្មោះ</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(disableProvider, index) in disableProviderList.slice(2*parseInt(disableProviderList.length / 3))">
						<md-table-cell>{{disableProvider.provider_name}}</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="disableProvider.upd_id != null">មិនអាចលេង</span>
							<span class="green" v-if="disableProvider.upd_id == null">អាចលេង</span>
						</md-table-cell>
						<md-table-cell>
							<div style="cursor: pointer;" v-if="disableProvider.upd_id != null" @click="enableProvider(disableProvider.upd_id)">
								<md-icon>play_circle</md-icon>
								<md-tooltip md-direction="top">ដាក់អោយលេង</md-tooltip>
							</div>
							<div style="cursor: pointer;" v-if="disableProvider.upd_id == null" @click="disableProviderFunc(disableProvider.provider_id)">
								<md-icon>stop_circle</md-icon>
								<md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip>
							</div>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>



			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ប្រវត្តិដាក់ប្រាក់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="depositList.length > 0">
					<md-table-row>
						<!-- <md-table-head>ល.រ</md-table-head> -->
						<md-table-head>ល.រ</md-table-head>
						<md-table-head>លេខកូដប្រតិបត្តិការ</md-table-head>
						<md-table-head>ចំនួនទឹកប្រាក់</md-table-head>
						<md-table-head>អ្នកអនុម័ត</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(deposit, index) in depositList">
						<md-table-cell>{{index+1}}</md-table-cell>
						<md-table-cell><b>{{deposit.id}}</b><br>{{config.datelify(deposit.created_date)}} ({{config.timelify(deposit.created_date)}})</md-table-cell>
						<md-table-cell><b>{{config.moneylify(deposit.amount)}}</b><br>{{deposit.payment_type}}</md-table-cell>
						<md-table-cell>
							<span v-if="deposit.approve_by != null"><b>{{deposit.approve_by}}</b><br>{{config.datelify(deposit.approved_date)}} ({{config.timelify(deposit.approved_date)}})</span>
							<span v-else><b>មិនមាន</b></span>
						</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="deposit.status == 0">{{ config.getDepositStatus(deposit.status) }}</span>
							<span class="green" v-if="deposit.status == 1">{{ config.getDepositStatus(deposit.status) }}</span>
							<span class="error" v-if="deposit.status == 2">{{ config.getDepositStatus(deposit.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<router-link :to="'/deposits/detail/' + deposit.id">
								<md-button class="md-just-icon md-simple md-primary">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">មើលលំអិត</md-tooltip>
								</md-button>
							</router-link>
						</md-table-cell>

					</md-table-row>
				</md-table>
				<h4 class="text-center" v-if="depositList.length == 0 && depositLoaded">មិនមានដាក់ប្រាក់</h4>
				<!-- <div class="places-buttons text-center" v-if="loadMore">
					<md-button class="md-primary" @click="getPackage(true)">បង្ហាញបន្ថែម</md-button>
				</div> -->
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ប្រវត្តិដកប្រាក់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="withdrawList.length > 0">
					<md-table-row>
						<!-- <md-table-head>ល.រ</md-table-head> -->
						<md-table-head>ល.រ</md-table-head>
						<md-table-head>លេខកូដប្រតិបត្តិការ</md-table-head>
						<md-table-head>ចំនួនទឹកប្រាក់</md-table-head>
						<md-table-head>គណនីធនាគារ</md-table-head>
						<md-table-head>អ្នកអនុម័ត</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(withdraw, index) in withdrawList">
						<md-table-cell>{{index+1}}</md-table-cell>
						<md-table-cell><b>{{withdraw.id}}</b><br>{{config.datelify(withdraw.created_date)}} ({{config.timelify(withdraw.created_date)}})</md-table-cell>
						<md-table-cell><b>{{config.moneylify(withdraw.amount)}}</b><br>{{withdraw.payment_type}}</md-table-cell>
						<md-table-cell><b>{{withdraw.username}} ({{config.moneylify(withdraw.balance)}})</b><br>{{withdraw.name}}</md-table-cell>
						<md-table-cell>
							<span v-if="withdraw.approve_by != null"><b>{{withdraw.approve_by}}</b><br>{{config.datelify(withdraw.approved_date)}} ({{config.timelify(withdraw.approved_date)}})</span>
							<span v-else><b>មិនមាន</b></span>
						</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="withdraw.status == 0">{{ config.getWithdrawStatus(withdraw.status) }}</span>
							<span class="green" v-if="withdraw.status == 1">{{ config.getWithdrawStatus(withdraw.status) }}</span>
							<span class="error" v-if="withdraw.status == 2">{{ config.getWithdrawStatus(withdraw.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<router-link :to="'/withdraws/detail/' + withdraw.id">
								<md-button class="md-just-icon md-simple md-primary">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">មើលលំអិត</md-tooltip>
								</md-button>
							</router-link>
						</md-table-cell>

					</md-table-row>
				</md-table>
				<h4 class="text-center" v-if="withdrawList.length == 0 && withdrawLoaded">មិនមានដកប្រាក់</h4>
				<!-- <div class="places-buttons text-center" v-if="loadMore">
					<md-button class="md-primary" @click="getPackage(true)">បង្ហាញបន្ថែម</md-button>
				</div> -->
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="resetPasswordDialogActive" md-title="តើអ្នកពិតជាចង់បង្កើតពាក្យសំងាត់ថ្មីចំពោះគណនីនេះមែនឬ ?"
			md-content="ប្រព័ន្ធនឹងធ្វើការបង្កើតពាក្យសំងាត់ថ្មី រួចបង្ហាញពាក្យសំងាត់ថ្មីនោះដល់អ្នក។" md-confirm-text="ដាក់ថ្មី" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="resetPassword" />
		<md-dialog-confirm :md-active.sync="resetPasswordDialogNewPasswordActive" md-title="ពាក្យសំងាត់ថ្មី"
			:md-content="newPassword" md-confirm-text="OK" @md-confirm="onCancel" />
	</div>


</template>

<script>
	import { Datetime } from 'vue-datetime';
	import StatsCard from '@/components/Cards/StatsCard'
	export default {
		components: { Datetime, StatsCard },
		created() {

			// this.getLocation();
			// this.getSettings();
			this.getClient();
			this.searchDeposit();
			this.searchWithdraw();
			// this.getPackage();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				client: {
					hash: "",
					name: "",
					phone: "",
					note: "",
					created_date: ""
				},
				data: {
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0
				},
				loadMore: false,
				depositList: [],
				depositLoaded: false,
				withdrawList: [],
				withdrawLoaded: false,
				disableProviderList: [],
				// providerTodayList: [],
				depositLoadMore: false,
				withdrawLoadMore: false,
				loadMoreToday: false,
				resetPasswordDialogActive: false,
				resetPasswordDialogNewPasswordActive: false,
				newPassword: ""
			}
		},
		computed: {
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/user/get/" + this.$route.params.hash_id).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
				this.$http.get(this.config.api + "/admin/user/get_stat/" + this.$route.params.hash_id).then(data => {
					this.data = data.body.data
				})

				this.getDisableProvider();
			},
			getDisableProvider() {
				this.$http.get(this.config.api + "/admin/user/get_disable_provider/" + this.$route.params.hash_id).then(data => {
					this.disableProviderList = data.body.data
				})
			},
			enableProvider(upd_id) {
				this.$http.post(this.config.api + "/admin/user/enable_provider", {
					upd_id
				}).then(data => {
					this.getDisableProvider();
				});
			},
			disableProviderFunc(provider_id) {
				this.$http.post(this.config.api + "/admin/user/disable_provider", {
					provider_id,
					user_hash: this.$route.params.hash_id
				}).then(data => {
					this.getDisableProvider();
				});
			},
			// getBetToday(more = false) {
			// 	this.$http.get(this.config.api + "/admin/user/get_bet_today/" + this.$route.params.hash_id).then(data => {
			// 		this.loaded = true;
			// 		if (data.body.data.length == 50) this.loadMoreToday = true;
			// 		else this.loadMoreToday = false;
			// 		this.providerTodayList = more ? this.providerTodayList.concat(data.body.data) : data.body.data;
			// 		// this.clientList = data.body.data;
			// 	})
			// },
			searchDeposit(more = false) {
				this.$http.post(this.config.api + "/admin/deposit/search", {
					text: this.$route.params.hash_id,
					status: "",
					offset: more ? this.depositList.length : 0
				}).then(data => {
					this.depositLoaded = true;
					if (data.body.data.length == 100) this.depositLoadMore = true;
					else this.depositLoadMore = false;
					this.depositList = more ? this.depositList.concat(data.body.data) : data.body.data;
				})
			},
			searchWithdraw(more = false) {
				this.$http.post(this.config.api + "/admin/withdraw/search", {
					text: this.$route.params.hash_id,
					status: "",
					offset: more ? this.withdrawList.length : 0
				}).then(data => {
					this.withdrawLoaded = true;
					if (data.body.data.length == 100) this.withdrawLoadMore = true;
					else this.withdrawLoadMore = false;
					this.withdrawList = more ? this.withdrawList.concat(data.body.data) : data.body.data;
				})
			},
			resetPassword() {
				if(this.resetPasswordDialogActive) {
					this.$http.post(this.config.api + "/admin/user/reset_password", {
						hash_id: this.$route.params.hash_id
					}).then(data => {
						if (data.body.status == 'success') {
							this.resetPasswordDialogNewPasswordActive = true;
							this.newPassword = data.body.data.new_password;
						}
					})
				} else {
					this.resetPasswordDialogActive = true;
				}
			},
			verify() {
				this.$http.post(this.config.api + "/admin/user/verify", {
					hash_id: this.$route.params.hash_id
				}).then(data => {
					if (data.body.status == 'success') {
						this.getClient();
						this.$notification.notify({
							message: "បានបញ្ជាក់គណនីដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
					}
				})
			},
			unverify() {
				this.$http.post(this.config.api + "/admin/user/unverify", {
					hash_id: this.$route.params.hash_id
				}).then(data => {
					if (data.body.status == 'success') {
						this.getClient();
						this.$notification.notify({
							message: "បានដកការបញ្ជាក់គណនីដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
					}
				})
			},
			onCancel() {
				this.resetPasswordDialogActive = false;
				this.resetPasswordDialogNewPasswordActive = false;
				this.newPassword = "";
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Detail.vue